module.exports = __webpack_public_path__ + "531a9ba0017689b0c473ad661355a6c2.png";